<div class="item user-block" *ngIf="userBlockIsVisible()">
   
    <div class="user-block-picture">
        <div class="user-block-status">
            <img class="img-thumbnail rounded-circle" [src]="user.picture" alt="Avatar" />
            <div class="circle bg-success circle-lg"></div>
        </div>
    </div>
   
    <div class="user-block-info">
        <span class="user-block-name">{{ 'sidebar.WELCOME' | translate }}  John</span>
        <span class="user-block-role">Programmer</span>
    </div>
</div>
